var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"app-content-heading"},[_vm._t("default"),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"app-content-heading__loader icon-loading-small"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }